import endpoint from "../../../config/endpoints";

export const RU_TARGET_IMPORT_API = {
  exportExcel:
    endpoint.exportData +
    "/retail-unit-wise-target-header-detail-with-assign-excel",
  validate:
    endpoint.importData +
    "/validate-retail-unit-wise-target-header-detail-with-assign-data",
  save:
    endpoint.importData +
    "/retail-unit-wise-target-header-detail-with-assign-data",
  excelFormKey: "ruTargetHeaderDetailWithAssignExcel",
};
